export default "__VITE_ASSET__Ckb4hrmh__"